import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table, Form } from "react-bootstrap"; // Import Form from react-bootstrap
import { selectChangedOptions } from "../../../redux/selectors";
import { diffWords } from "diff"; // Import diffWords from diff

const ChangedOptions = () => {
    const changedOptionsList = useSelector(selectChangedOptions); // Assuming the selector is the same
    const [viewChanged, setViewChanged] = useState({});
    const [highlightChangesEnabled, setHighlightChangesEnabled] = useState(false);

    const rowStyle = { backgroundColor: '#f9f9f9', padding: '10px', margin: '10px 0' };
    const labelStyle = { fontWeight: 'bold' };

    const handleToggleChange = (index) => {
        setViewChanged((prevState) => ({
            ...prevState,
            [index]: prevState[index] === undefined ? false : !prevState[index]
        }));
    };

    const highlightChanges = (original, changed) => {
        if (!original) original = "";
        if (!changed) changed = "";
        const diff = diffWords(original, changed);
        return diff.map((part, index) => {
            const backgroundColor = part.added ? 'lightgreen' : part.removed ? 'salmon' : 'transparent';
            return <span key={index} style={{ backgroundColor }}>{part.value}</span>;
        });
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div>
                    <strong>Total Items: {changedOptionsList.length}</strong>
                </div>
                <Form.Check 
                    type="checkbox"
                    label="Highlight Changes"
                    checked={highlightChangesEnabled}
                    onChange={(e) => setHighlightChangesEnabled(e.target.checked)}
                />
            </div>
            <Table striped bordered hover>
                <tbody>
                    {changedOptionsList.map((changedOptionItem, index) => (
                        <tr key={changedOptionItem.ID ?? index} style={rowStyle}>
                            <td colSpan="2">
                                <div style={{ marginBottom: '10px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <span style={labelStyle}>Option Number:</span> {changedOptionItem.OptionNumber}
                                        </div>
                                        <div>
                                            <Form.Check 
                                                type="switch"
                                                id={`custom-switch-${index}`}
                                                label={viewChanged[changedOptionItem.ID ?? index] !== undefined ? (viewChanged[changedOptionItem.ID ?? index] ? "Changed" : "Original") : "Changed"}
                                                checked={viewChanged[changedOptionItem.ID ?? index] !== undefined ? viewChanged[changedOptionItem.ID ?? index] : true}
                                                onChange={() => handleToggleChange(changedOptionItem.ID ?? index)}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                                        <div>
                                            <span style={labelStyle}>Name: </span> 
                                            {viewChanged[changedOptionItem.ID ?? index] !== false
                                                ? (highlightChangesEnabled 
                                                    ? highlightChanges(changedOptionItem.MasterName, changedOptionItem.ChangedPartName) 
                                                    : changedOptionItem.ChangedPartName)
                                                : changedOptionItem.MasterName}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ marginBottom: '25px' }}>
                                    <strong>Description:</strong>
                                    <div>
                                        {viewChanged[changedOptionItem.ID ?? index] !== false
                                            ? (highlightChangesEnabled 
                                                ? highlightChanges(changedOptionItem.MasterDescription, changedOptionItem.ChangedDescription) 
                                                : changedOptionItem.ChangedDescription)
                                            : changedOptionItem.MasterDescription}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ChangedOptions;
